// extracted by mini-css-extract-plugin
module.exports = {"footerText":"Footer_footerText__vHRSn","footer":"Footer_footer__1jIKm"};